
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor03Off as ObiBipolar_transistor03OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-03-off.js';
 
 
 

 
 export const ObiBipolar_transistor03Off = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-03-off',
   elementClass: ObiBipolar_transistor03OffElement,
   events: {
     
   }
  });
 
 